import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,[_c(VListItemIcon,{staticClass:"mr-5"},[_c(VIcon,{attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.icon))])],1),_c(VListItemContent,{staticClass:"mr-0"},[_c(VListItemTitle,[_vm._v(_vm._s(_vm.item))]),_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.label))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }